<template>
	<v-row no-gutters>
		<v-col cols="12" md="6" class="pr-md-1">
			<table width="100%" class="mt-4 show-dialog-table">
				<tbody>
					<ShowDetailRecord :columnName="'事例番号'" :value="problem_case.case_number" />
					<ShowDetailRecord :columnName="'事例名'" :value="problem_case.name" />
					<ShowDetailRecord :columnName="'対象タイプ'" :value="problem_case.case_type_i18n" />
					<ShowDetailRecord
						:columnName="'対象分類'"
						:value="problem_case.product_category ? problem_case.product_category.name : ''"
					/>
					<ShowDetailRecord
						:columnName="'対象子分類'"
						:value="problem_case.product_sub_category ? problem_case.product_sub_category.name : ''"
					/>
					<ShowDetailRecord
						:columnName="'対象製品名'"
						:value="problem_case.product ? problem_case.product.name : ''"
					/>
					<ShowDetailRecord
						:columnName="'対象品番'"
						:value="problem_case.product ? problem_case.product.product_code : ''"
					/>
					<ShowDetailRecord :columnName="'作成者'" :value="problem_case.user.full_name" />
					<ShowDetailRecord
						:columnName="'作成日'"
						:value="common.formatDateTime(problem_case.created_at)"
					/>
					<ShowDetailRecord
						:columnName="'最終更新日'"
						:value="common.formatDateTime(problem_case.updated_at)"
					/>

					<ShowDetailRecord :columnName="'添付ファイル'">
						<template v-slot:value>
							<a
								v-for="file in files()"
								:key="file.id"
								:href="file.url"
								class="d-block"
								target="_blank"
							>
								{{ file.name }}
							</a>
						</template>
					</ShowDetailRecord>
				</tbody>
			</table>
		</v-col>
		<v-col cols="12" md="6" class="pl-md-1">
			<table width="100%" class="mt-4 show-dialog-table">
				<tbody>
					<ShowDetailRecord :columnName="'備考'" :value="problem_case.description" text />
				</tbody>
			</table>
			<h3 class="font-weight-bold mt-3">添付ファイル削除履歴</h3>
			<template v-if="!$vuetify.breakpoint.xs">
				<table v-if="deletedFileInfos().length > 0">
					<tr v-for="file in deletedFileInfos()" :key="file.id">
						<td class="pl-3">{{ common.formatDate(file.destroy_date) }}</td>
						<td class="pl-3">{{ file.name }}</td>
						<td class="pl-3">{{ file.destroy_user.full_name }}</td>
					</tr>
				</table>
				<p v-else>なし</p>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row v-if="deletedFileInfos().length > 0">
					<v-col cols="12" v-for="file in deletedFileInfos()" :key="file.id">
						<p class="pl-3">{{ common.formatDate(file.destroy_date) }}</p>
						<p class="pl-3">{{ file.name }}</p>
						<p class="pl-3">{{ file.destroy_user.full_name }}</p>
					</v-col>
				</v-row>
				<p v-else>なし</p>
			</template>
		</v-col>
	</v-row>
</template>

<script>
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		problem_case: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			common,
		}
	},

	methods: {
		files() {
			if (!this.problem_case.attached_files) {
				return []
			}
			return this.problem_case.attached_files.filter((file) => file.destroy_flag == false)
		},
		deletedFileInfos() {
			if (!this.problem_case.attached_files) {
				return []
			}
			return this.problem_case.attached_files.filter((file) => file.destroy_flag == true)
		},
	},
	watch: {
		problem_case: {
			handler(val, oldVal) {
				this.problem_case = val
			},
			deep: true,
		},
	},
}
</script>
